import { Skeleton, Stack } from "@mui/material";
import BoxLegend from "../../../../common/BoxLegend";
import { useEffect, useRef, useState } from "react";
import { filterTickets, getSLAIndicators } from "../../../../../services/ticket.service";
import { TicketsFilterFormModel } from "../../../../../models/ticket.model";
import { TICKET_STATUS_OPEN } from "../../../../../assets/appConstants/constants";
import { useProject } from "../../../../../context/ProjectContext";
import { useTicketsFilterContext } from "../../../../../context/TicketsFilterContext";
import FilterChip from "../../../../common/ActionChip/FilterChip";
import { getPriorityColor } from '../../../../../utilities/functions';
import { APIResponseModel } from "../../../../../models/api-call";


interface SLAIndicatorsBarProps {
  setTicketsList: (p: any) => void
  resetPrimaryFilter: () => void
  filteredSLACode?: any
  setFilteredSLACode: (p: any) => void
  setLoadingTickets: (p: any) => void
  resetSLAFilters?: boolean
}

export default function SLAIndicatorsBar({ setTicketsList, resetPrimaryFilter, filteredSLACode, setFilteredSLACode,
  setLoadingTickets, resetSLAFilters }: SLAIndicatorsBarProps) {

  const { selectedProject } = useProject()
  const { setDefaultTicketsFilter, checkAppliedFilters } = useTicketsFilterContext()
  const [loadingSLAIndicators, setLoadingSLAIndicators] = useState<boolean>(false)

  const [filterSLAForm, setFilterSLAForm] = useState<TicketsFilterFormModel>(
    {
      number: [],
      project_id: selectedProject
    }
  )

  let SLAValues = useRef<[{ code: string, name: string, nu_tkts: [] }] | []>([])
  const [reloadSLAIndicators, setReloadSLAIndicators] = useState<boolean>(false)
  const [slaIndicators, setSLAIndicators] = useState<any[]>([])

  const thirty_sec = 30000
  const one_sec = 1000

  useEffect(() => {
    setFilteredSLACode('')
  }, [resetSLAFilters])

  const setFilter = () => {
    if (filteredSLACode) {
      setLoadingTickets(true)
      Promise.all([filterTickets(selectedProject, filterSLAForm)]).then(function (results) {
        setTicketsList(results[0])
        setLoadingTickets(false)
      }).catch((error) => {
        setLoadingTickets(false)
      });
    }
  }

  useEffect(setFilter, [filteredSLACode])

  const handleSubmit = (data: { code: string, name: string, nu_tkts: [] }) => {
    if (!filteredSLACode) {
      console.table(data)
      setDefaultTicketsFilter()
      checkAppliedFilters({ number: '', status: TICKET_STATUS_OPEN, project_id: selectedProject })
      setFilterSLAForm({ ...filterSLAForm, number: data.nu_tkts, project_id: selectedProject })
      setFilteredSLACode(data.code)
    } else {
      setFilteredSLACode('')
      resetPrimaryFilter()
    }
  }

  const loadSLAIndicators = () => {
    setLoadingSLAIndicators(true)
    Promise.all([getSLAIndicators(selectedProject)])
      .then(function (results: APIResponseModel[]) {
        SLAValues.current = results[0].data
        setReloadSLAIndicators(!reloadSLAIndicators)
        setTimeout(() => { setLoadingSLAIndicators(false) }, one_sec)
      }).catch((error) => {
        setTimeout(() => { setLoadingSLAIndicators(false) }, one_sec)
      }
      )
  }

  useEffect(loadSLAIndicators, [selectedProject])

  useEffect(() => {
    const intervalId = setInterval(() => {
      loadSLAIndicators()
    }, thirty_sec);

    return () => clearInterval(intervalId);

  }, [selectedProject]);

  const makeBody = () => {
    let new_body: any = []
    for (let i = 0; i < SLAValues.current.length; i++) {
      new_body.push(
        <FilterChip
          key={SLAValues.current[i].code}
          label={SLAValues.current[i].name}
          counter={SLAValues.current[i].nu_tkts.length}
          color={getPriorityColor(SLAValues.current[i].code)}
          textColor="white"
          disabled={SLAValues.current[i].code !== filteredSLACode && filteredSLACode !== ''}
          onClick={() => { handleSubmit(SLAValues.current[i]) }}
        />
      )
    }
    setSLAIndicators(new_body)
  }

  useEffect(makeBody, [reloadSLAIndicators, filteredSLACode])

  return (
    (slaIndicators.length > 0) ? (
      <div className="slaindicators-bar">
        <BoxLegend
          title="Necesita Actualización (Prioridad)"
          content={loadingSLAIndicators ? <>
            <Skeleton variant="text" width={300} height={11} />
            <Skeleton variant="text" width={300} height={11} />
          </>
            : <Stack useFlexGap flexWrap="wrap" direction="row" spacing={1}>{slaIndicators}</Stack>}
        />
      </div>) : <></>
  )
}